import './w-jump-links.component.scss'
import { hotModuleReload } from '../../../components/common/utilities/hot-module-reload'
import smoothscroll from 'smoothscroll-polyfill'
import { downArrow, viewAllIcon } from './index'
import { createTokenFromText } from '../../../helpers/createTokenFromText'
import { clientConfig } from '../../../config/client-config'
smoothscroll.polyfill()

export const generateMissingIDs = (elements) => {
  elements.forEach((element) => {
    if (!element.getAttribute('id')) {
      const h2Text = element.innerText || element.textContent
      element.id = createTokenFromText(h2Text)
    }
  })
  return elements
}

const createNewNode = (h2Text, h2Id) => {
  const newNode = document.createElement('a')
  newNode.href = `#${h2Id}`
  newNode.setAttribute('data-h2-id', h2Id)
  newNode.setAttribute('class', 'w-jump-links__item sb-link-primary')
  newNode.setAttribute('data-which-id', 'article-anchor-link')
  newNode.innerHTML = `
    <span class="w-jump-links__item_icon">${downArrow}</span>
    <span class="w-jump-links__item_text">${h2Text}</span>`

  return newNode
}

export const updateJumplinks = (h2Nodes: NodeList): HTMLElement[] => {
  const jumplinkNodeArray = []
  const h2NodesArray = Array.from(h2Nodes)

  h2NodesArray.forEach((h2Node: HTMLElement) => {
    const h2Text = h2Node.innerText || h2Node.textContent
    if (h2Text.trim()) {
      jumplinkNodeArray.push(createNewNode(h2Text, h2Node.id))
    }
  })

  return jumplinkNodeArray
}

export const jumplinksContainer = (
  jumpLinksNodes: HTMLElement[],
  jumpLinkClickHandler?,
  expanderClickHandler?
): HTMLElement => {
  const wrapper = document.querySelector('.w-jump-links-wrapper') as HTMLElement
  let title = wrapper.querySelector('.w-jump-links-title')
  if (!wrapper.contains(title)) {
    title = document.createElement('div')
    title.className = 'w-jump-links-title'
    const spanText = document.createElement('span')
    spanText.append('In this article')
    title.append(spanText)
    wrapper.append(title)
  }

  let content = wrapper.querySelector('.w-jump-links-content')
  if (!wrapper.contains(content)) {
    content = document.createElement('div')
    content.className = 'w-jump-links-content'
  }
  content.innerHTML = ''
  jumpLinksNodes.forEach((jumpLink) => {
    content.append(jumpLink)
  })

  let buttonWrapper = wrapper.querySelector('.w-jump-links-button')
  if (!wrapper.contains(buttonWrapper)) {
    const button = document.createElement('button')
    button.type = 'button'
    button.id = 'w-view-all-btn'
    button.setAttribute('aria-expanded', 'false')
    button.addEventListener('click', expanderClickHandler)
    button.innerHTML = `
          <span class="w-jump-links-button__text sb-link-primary">View all</span>
          <span class="w-jump-links-button__icon"> ${viewAllIcon} </span>
          `
    buttonWrapper = document.createElement('div')
    buttonWrapper.className = 'w-jump-links-button'
    buttonWrapper.append(button)
    wrapper.append(buttonWrapper)
  }

  jumpLinksNodes.forEach((jumpLink: HTMLElement, index) => {
    jumpLink.addEventListener('click', jumpLinkClickHandler)
    if (index < clientConfig.jumpLinks.max) {
      jumpLink.classList.add('alwaysShown')
    }
  })
  wrapper.insertBefore(content, buttonWrapper)

  if (jumpLinksNodes.length <= clientConfig.jumpLinks.max) {
    wrapper.querySelector('.w-jump-links-button').remove()
  } else {
    buttonWrapper.querySelector('#w-view-all-btn').addEventListener('click', expanderClickHandler)
  }

  return wrapper
}

export const refreshJumplinks = (h2Elements, jumpLinksWrapper): void => {
  if (h2Elements.length >= clientConfig.jumpLinks.min) {
    const validH2Elements = generateMissingIDs(h2Elements)
    const updatedJumpLinks: HTMLElement[] = updateJumplinks(validH2Elements)

    if (updatedJumpLinks.length >= clientConfig.jumpLinks.min) {
      jumplinksContainer(updatedJumpLinks, handleClick, handleExpanderClick)
    } else {
      jumpLinksWrapper.remove()
    }
  } else {
    jumpLinksWrapper.remove()
  }
}

window.addEventListener('load', () => {
  const h2Elements = document.querySelectorAll('.w-article-wrapper h2')
  const jumpLinksWrapper = document.querySelector('.w-jump-links-wrapper') as HTMLElement

  refreshJumplinks(h2Elements, jumpLinksWrapper)
  actionJumpLink()
})

const scrollIntoView = (element: Element): void => {
  window.scrollTo({
    top: document.documentElement.scrollTop + element.getBoundingClientRect().top,
    behavior: 'smooth',
  })
}

export const actionJumpLink = (): void => {
  const { hash } = window.location
  if (hash) {
    const h2Element = document.querySelector(`.w-article-wrapper h2${hash}`)
    h2Element && scrollIntoView(h2Element)
  }
}

const handleClick = (e): void => {
  e.preventDefault()
  const { h2Id } = (e.currentTarget as HTMLElement).dataset
  const scrollTarget = document.querySelector(`#${h2Id}`)
  if (h2Id && scrollTarget) {
    scrollIntoView(scrollTarget)
    history.pushState(null, null, `#${h2Id}`)
  }
}

const handleExpanderClick = (e): void => {
  const expander = e.currentTarget as HTMLElement
  const jumpLinksWrapper = document.querySelector('.w-jump-links-content') as HTMLElement
  const buttonText = expander.querySelector('.w-jump-links-button__text') as HTMLElement
  const isExpanded = expander.getAttribute('aria-expanded') === 'true'

  if (isExpanded) {
    jumpLinksWrapper.classList.remove('expanded')
    jumpLinksWrapper.style.maxHeight = jumpLinksWrapper.dataset.maxHeight
    expander.setAttribute('aria-expanded', 'false')
    buttonText.innerText = 'View all'
  } else {
    jumpLinksWrapper.classList.add('expanded')
    jumpLinksWrapper.style.maxHeight = jumpLinksWrapper.dataset.minHeight
    expander.setAttribute('aria-expanded', 'true')
    buttonText.innerText = 'Hide all'
  }
}

hotModuleReload()
